import request from '@/utils/request'
//首页新闻
// export function homeNewsList(data) {
//     return request({
//         url: '/goldenseed/web/newList',
//         method: 'post',
//         data: data
//     })
// }
// 首页申报记录
export function homeList(data) {
    return request({
        url: '/goldenseed/web/passListByType',
        method: 'post',
        data:data
    })
}

//首页数据
export function webIndex() {
    return request({
        url: '/goldenseed/web/index',
        method: 'get'
    })
}
//首页新闻政策
export function indexNews(data) {
    return request({
        url: '/goldenseed/web/indexNews',
        method: 'post',
        data:data
    })
}

//footer链接
export function bottomLinks() {
    return request({
        url: '/goldenseed/web/bottomLinks',
        method: 'get'
    })
}

//新闻政策详情
export function indexNewsView(id) {
    return request({
        url: '/goldenseed/web/indexNewsView?id='+id,
        method: 'get'
    })
}

// 行政区划一级结构
// export function getAllArea(code) {
//     return request({
//         url: '/sys/areacode/rest/listAllIpmSysAreacode?code='+code,
//         method: 'get',
//     })
// }

// 行政区划
export function getAllArea(code) {
    return request({
        url: '/sys/ipmSysAreacode/tree?code='+code,
        method: 'get',
    })
}
//字典
export function getDicts(typeCode) {
    return request({
        url: '/sys/dict/rest/findDictItemByDictType?typeCode='+typeCode,
        method: 'get',
    })
}
//字典2
export function findDictItem(code) {
    return request({
        url: '/sys/dict/rest/findDictItem?code='+code,
        method: 'get',
    })
}
//删除自主商标品牌建设
export function brandDelete(id) {
    return request({
        url: '/goldenseed/basic/brandConstruction/delete?id='+id,
        method: 'get',
    })
}
//查询自主商标品牌建设详情
export function brandView(id) {
    return request({
        url: '/goldenseed/basic/brandConstruction/findById?id='+id,
        method: 'get',
    })
}
//自主商标品牌建设列表查询
export function brandList(data) {
    return request({
        url: '/goldenseed/basic/brandConstruction/findPageByQuery',
        method: 'post',
        data: data
    })
}
//自主商标品牌建设新增
export function brandSave(data) {
    return request({
        url: '/goldenseed/basic/brandConstruction/save',
        method: 'post',
        data: data
    })
}
//自主商标品牌建设更新
export function brandUpdate(data) {
    return request({
        url: '/goldenseed/basic/brandConstruction/update',
        method: 'post',
        data: data
    })
}
//删除当前重点研发项目
export function importantDelete(id) {
    return request({
        url: '/goldenseed/basic/researchProjects/delete?id='+id,
        method: 'get',
    })
}
//查询当前重点研发项目详情
export function importantView(id) {
    return request({
        url: '/goldenseed/basic/researchProjects/findById?id='+id,
        method: 'get',
    })
}
//当前重点研发项目查询
export function importantList(data) {
    return request({
        url: '/goldenseed/basic/researchProjects/findPageByQuery',
        method: 'post',
        data: data
    })
}
//当前重点研发项目新增
export function importantSave(data) {
    return request({
        url: '/goldenseed/basic/researchProjects/save',
        method: 'post',
        data: data
    })
}
//当前重点研发项目更新
export function importantUpdate(data) {
    return request({
        url: '/goldenseed/basic/researchProjects/update',
        method: 'post',
        data: data
    })
}
//删除相关专利或技术获各级奖励情况
export function prizeDelete(id) {
    return request({
        url: '/goldenseed/basic/patentAwards/delete?id='+id,
        method: 'get',
    })
}
//查询相关专利或技术获各级奖励情况详情
export function prizeView(id) {
    return request({
        url: '/goldenseed/basic/patentAwards/findById?id='+id,
        method: 'get',
    })
}
//相关专利或技术获各级奖励情况列表查询
export function prizeList(data) {
    return request({
        url: '/goldenseed/basic/patentAwards/findPageByQuery',
        method: 'post',
        data: data
    })
}
//相关专利或技术获各级奖励情况新增
export function prizeSave(data) {
    return request({
        url: '/goldenseed/basic/patentAwards/save',
        method: 'post',
        data: data
    })
}
//相关专利或技术获各级奖励情况更新
export function prizeUpdate(data) {
    return request({
        url: '/goldenseed/basic/patentAwards/update',
        method: 'post',
        data: data
    })
}
//删除经济指标数据
export function econDelete(id) {
    return request({
        url: '/goldenseed/basic/economicIndicators/delete?id='+id,
        method: 'get',
    })
}
//查询经济指标数据详情
export function econView(id) {
    return request({
        url: '/goldenseed/basic/economicIndicators/findById?id='+id,
        method: 'get',
    })
}
//经济指标数据列表查询
export function econList(data) {
    return request({
        url: '/goldenseed/basic/economicIndicators/findPageByQuery',
        method: 'post',
        data: data
    })
}
//经济指标数据新增
export function econSave(data) {
    return request({
        url: '/goldenseed/basic/economicIndicators/save',
        method: 'post',
        data: data
    })
}
//经济指标数据更新
export function econUpdate(data) {
    return request({
        url: '/goldenseed/basic/economicIndicators/update',
        method: 'post',
        data: data
    })
}
//删除专利池运营情况
export function poolDelete(id) {
    return request({
        url: '/goldenseed/basic/patentPoolOperations/delete?id='+id,
        method: 'get',
    })
}
//查询专利池运营情况详情
export function poolView(id) {
    return request({
        url: '/goldenseed/basic/patentPoolOperations/findById?id='+id,
        method: 'get',
    })
}
//专利池运营情况列表查询
export function poolList(data) {
    return request({
        url: '/goldenseed/basic/patentPoolOperations/findPageByQuery',
        method: 'post',
        data: data
    })
}
//专利池运营情况新增
export function poolSave(data) {
    return request({
        url: '/goldenseed/basic/patentPoolOperations/save',
        method: 'post',
        data: data
    })
}
//专利池运营情况更新
export function poolUpdate(data) {
    return request({
        url: '/goldenseed/basic/patentPoolOperations/update',
        method: 'post',
        data: data
    })
}

//删除专利转化指标数据
export function transDelete(id) {
    return request({
        url: '/goldenseed/basic/patentConversionMetrics/delete?id='+id,
        method: 'get',
    })
}
//查询专利转化指标数据详情
export function transView(id) {
    return request({
        url: '/goldenseed/basic/patentConversionMetrics/findById?id='+id,
        method: 'get',
    })
}
//专利转化指标数据列表查询
export function transList(data) {
    return request({
        url: '/goldenseed/basic/patentConversionMetrics/findPageByQuery',
        method: 'post',
        data: data
    })
}
//专利转化指标数据新增
export function transSave(data) {
    return request({
        url: '/goldenseed/basic/patentConversionMetrics/save',
        method: 'post',
        data: data
    })
}
//专利转化指标数据更新
export function transUpdate(data) {
    return request({
        url: '/goldenseed/basic/patentConversionMetrics/update',
        method: 'post',
        data: data
    })
}

//新增点赞
export function likesSave(data) {
    return request({
        url: '/goldenseed/application/ipmLikes/save',
        method: 'post',
        data: data
    })
}
//修改点赞
export function likesUpdate(data) {
    return request({
        url: '/goldenseed/application/ipmLikes/update',
        method: 'post',
        data: data
    })
}
//apply表单初始化获取id
export function applyInit(type) {
    return request({
        url: '/goldenseed/application/initApplication?type='+type,
        method: 'get',
    })
}

//入库标准
export function getNewList(data) {
    return request({
        url: '/goldenseed/web/storageStandard',
        method: 'post',
        data: data
    })
}
//apply表单初次提交
export function applySave(data) {
    return request({
        url: '/goldenseed/application/save',
        method: 'post',
        data: data
    })
}
//apply表单下一步保存
export function applyUpdate(data) {
    return request({
        url: '/goldenseed/application/update',
        method: 'post',
        data: data
    })
}
//apply表单最后提交（不可修改）
export function applySubmit(data) {
    return request({
        url: '/goldenseed/application/submit',
        method: 'post',
        data: data
    })
}
//apply表单初始化获取id
export function industryTreeBylevel() {
    return request({
        url: '/goldenseed/industry/tree?level=2',
        method: 'get'
    })
}
export function industryTreeBycode(code) {
    return request({
        url: '/goldenseed/industry/tree?code='+code,
        method: 'get'
    })
}
//apply表单根据id查询
export function applyView(id) {
    return request({
        url: '/goldenseed/application/findById?id='+id,
        method: 'get'
    })
}

//入库申请记录查询
export function applyHistory(data) {
    return request({
        url: '/goldenseed/application/frontFindPageByQuery',
        method: 'post',
        data: data
    })
}
//登录后获取用户信息
export function getUserInfo() {
    return request({
        url: '/sys/captcha/getCurrentUser',
        method: 'get'
    })
}
//用户中心异议记录查询
export function objectList(data) {
    return request({
        url: '/goldenseed/basic/ipmObjection/frontFindPageByQuery',
        method: 'post',
        data: data
    })
}

//异议反馈
export function addIpmObjection(data) {
    return request({
        url: '/goldenseed/basic/ipmObjection/save',
        method: 'post',
        data: data
    })
}
//异议详情
export function objectView(id) {
    return request({
        url: '/goldenseed/basic/ipmObjection/findById?id='+id,
        method: 'get'
    })
}
//异议申报页详情
export function objectApplyView(id) {
    return request({
        url: '/goldenseed/application/ipmGoldenSeedCompany/findById?id='+id,
        method: 'get'
    })
}
//企业基本信息
export function companyinfo(id) {
    return request({
        url: '/goldenseed/application/ipmGoldenSeedCompany/frontFindById?id='+id,
        method: 'get'
    })
}
//获取底部信息
export function bottomNav() {
    return request({
        url: '/goldenseed/web/bottomNav',
        method: 'get'
    })
}
//分页查询保护中心预审IPC分类号
export function industryIpc(data) {
    return request({
        url: '/goldenseed/basic/basicIndustryIpc/findPageByQuery',
        method: 'post',
        data: data
    })
}
export function treeByCode(code) {
    return request({
        url: '/sys/ipmSysDictItem/treeByCode?code='+code,
        method: 'get'
    })
}

//浙江商标代理机构无从业人员名单
export function getNoemployList(data) {
    return request({
        url: '/goldenseed/web/trademarkAgency/noPractitionPersonList',
        method: 'post',
        data
    })
}
//浙江省商标代理机构信息表
export function getAgentorgList(data) {
    return request({
        url: '/goldenseed/basic/zjTrademarkAgency/frontFindPageByQuery',
        method: 'post',
        data
    })
}
//浙江省商标代理机构从业人员信息表
export function getAgentpersonList(data) {
    return request({
        url: '/goldenseed/basic/zjTrademarkAgencyPerson/frontFindPageByQuery',
        method: 'post',
        data
    })
}
export function checkbranded() {
    return request({
        url: '/goldenseed/application/ipmGoldenSeedCompany/judgeLibrary',
        method: 'get'
    })
}
//产业知识产权联盟信息公示
export function leagueList(data) {
    return request({
        url: '/goldenseed/basic/ipmPublicUnion/frontFindPageByQuery',
        method: 'post',
        data
    })
}
//专利导航服务基地信息公示
export function navigatorList(data) {
    return request({
        url: '/goldenseed/basic/ipmPublicNavigation/frontFindPageByQuery',
        method: 'post',
        data
    })
}
//产业知识产权运营中心信息公示
export function industryList(data) {
    return request({
        url: '/goldenseed/basic/ipmPublicIndustry/frontFindPageByQuery',
        method: 'post',
        data
    })
}
//首页获取保护中心、快维中心地址
export function getCenterAddress() {
    return request({
        url: '/sys/dict/rest/findDictItem?code=JZZ_ZJS_BHZX',
        method: 'get'
    })
}
